// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  width: 100%;
  overflow-x: auto;
  /* اسکرول افقی */
  margin-top: 20px;
  font-family: 'Vazir', sans-serif;
  -webkit-overflow-scrolling: touch;
  /* اسکرول نرم در موبایل */
}

.table-container table {
  width: 100%;
  min-width: 700px;
  /* پیش‌فرض برای دسکتاپ */
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  text-align: right;

}

th {
  text-align: right;

}

.table-container thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

.table-container thead th {
  padding: 12px 15px;
  font-weight: 600;
  color: #333;
  text-align: right;
}

.table-container tbody tr:nth-child(odd) {
  background-color: #F7F6FE;
  border-radius: 8px;

}

.table-container tbody tr:nth-child(even) {
  background-color: #ffffff;
}

.table-container tbody tr:hover {
  background-color: #f0f5ff;
}

.table-container tbody td {
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  color: #555;
}

.actions-cell {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 12px 15px;
}

.delete-btn {
  color: #e74c3c;
}

.tooltip-button {
  background: transparent;
  border: none;
  cursor: pointer;
  transition: transform 0.2s;
}

.tooltip-button:hover {
  transform: scale(1.1);
}

.tooltip-button img {
  width: 20px;
  height: 20px;
}

/* --- رسپانسیو --- */
@media (max-width: 768px) {
  .table-container table {
    width: 300px;
    /* عرض ثابت جدول در موبایل */
    font-size: 13px;
  }

  .table-container {
    width: 300px;
    /* عرض ثابت جدول در موبایل */
  }

  .table-container thead th,
  .table-container tbody td {
    padding: 10px 8px;
  }

  .tooltip-button img {
    width: 18px;
    height: 18px;
  }

  .actions-cell {
    flex-direction: column;
    /* دکمه‌ها زیر هم */
    gap: 5px;
  }
}

@media (max-width: 480px) {
  .table-container table {
    width: 300px;
    /* ثابت بودن عرض */
    font-size: 12px;
  }

  .table-container thead th,
  .table-container tbody td {
    padding: 8px 5px;
  }
}


/* ---------- مودال ---------- */
.edit-modal {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  overflow-y: auto;
}

.edit-modal-content {
  background: #fff;
  margin: 5% auto;
  padding: 20px;
  max-width: 480px;
  border-radius: 10px;
  position: relative;
}

.close-modal {
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
  font-size: 22px;
}

.edit-modal-content label {
  display: block;
  margin-top: 12px;
}

.edit-modal-content input,
.edit-modal-content select {
  width: 100%;
  padding: 6px;
  margin-top: 4px;
  box-sizing: border-box;
}

.actions-cell {
  display: flex;
  gap: 6px;
}

/* ---------- دکمه‌های tooltip ---------- */
.tooltip-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background-color: #EA6C22;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.tooltip {
  position: absolute;
  top: -20px;
  opacity: 0;
  background-color: #000000;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: 0.2s;
  pointer-events: none;
  letter-spacing: 0.5px;

  z-index: 99999;
}

.tooltip-btn:hover .tooltip {
  top: -50px;
  opacity: 1;
  transition-duration: 0.3s;
}


.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}




.delete-btn {
  color: #fff;
  background-color: #ebebeb;
  /* قرمز */
  border: none;
}



.product-cell {
  position: relative;
  padding: 6px 8px;
  font-size: 14px;
  vertical-align: middle;
}

.product-cell .product-name {
  font-weight: 500;
  color: #333;
  font-size: 15px;
}

.product-cell .product-quantity {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #EA6C22;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 0 6px;
  margin-left: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}



/* استایل خلاصه محصولات انتخاب‌شده */
.selected-products-summary {
  margin-top: 1rem;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fafafa;
}

.selected-products-summary h5 {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  /* اندازه متوسط */
}

.selected-products-summary ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.selected-products-summary li {
  font-size: 0.875rem;
  /* کمی کوچک‌تر برای لیست */
  margin-bottom: 0.25rem;
}

/* نمونه استایل برای دکمه افزودن محصول */
.btn-add-product {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  background: #4caf50;
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.btn-add-product:hover {
  background: #43a047;
}


h3.form-title {
  margin-bottom: 20px;
}





/* 
.selected-products-summary {
  margin-top: 1.5rem;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fdfdfd;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.selected-products-summary h5 {
  font-size: 16px;
  margin-bottom: 0.75rem;
  color: #333;
}

.selected-products-summary ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.selected-product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #555;
  transition: background-color 0.2s;
}

.selected-product-item:last-child {
  border-bottom: none;
}

.selected-product-item:hover {
  background-color: #f5f5f5;
}

.selected-product-item span {
  flex: 1;
}

.btn-remove-product {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #e74c3c;
  transition: transform 0.2s, color 0.2s;
}

.btn-remove-product:hover {
  transform: scale(1.3);
  color: #c0392b;
}
tr{
      background: #f9fafb;
    padding: 12px;
    border-radius: 14px;
    display: flex
;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e5e7eb;
} */


/* ===========================================================
   Selected Products Section
   =========================================================== */
.selected-products {
  direction: rtl;
  /* پشتیبانی از زبان فارسی */
  padding: 1.5rem;
  background-color: #f9f9f9;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  margin-top: 1rem;
}

/* ---------- عنوان بخش ---------- */
.selected-products .modal-title {
  font-size: 24px;
  /* می‌توانید اندازه دلخواه خود را جایگزین کنید */
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
  text-align: center;
}

/* ---------- لیست محصولات ---------- */
.selected-products ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.selected-products ul li {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 0.75rem 1rem;
  margin-bottom: 0.75rem;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.selected-products ul li:hover {
  background-color: #f3f3f3;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

/* ---------- متن محصول ---------- */
.selected-products ul li span {
  font-size: 16px;
  /* اندازه متن دلخواه */
  color: #555;
  line-height: 1.6;
}

/* ---------- دکمه حذف ---------- */
.selected-products ul li .delete-btn {
  margin-right: 1rem;
  /* فاصله از متن */
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
}

.selected-products ul li .delete-btn img,
.selected-products ul li .delete-btn svg {
  width: 20px;
  height: 20px;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.selected-products ul li .delete-btn:hover img,
.selected-products ul li .delete-btn:hover svg {
  transform: scale(1.1);
  opacity: 0.8;
}

.margin-btn {
  margin-right: 5px;
  /* در صورت نیاز به مارجین بیشتر */
}





.product-price span {
  font-weight: bold;
  color: #e63946;
  font-size: 12px;
}





.order-count {

  color: #1f2937;
  font-size: 16px;
  font-weight: 800;
  transition: all 0.3s ease;
  direction: rtl;

  padding-bottom: 20px;
}








/* ===============================
   📱 Phone Input Floating Label
================================= */
.phone-input-container {
  position: relative;
  width: 100%;
  margin: 20px 0;
}

.phone-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.phone-prefix {
  position: absolute;
  left: 12px;
  color: #888;
  font-size: 15px;
  pointer-events: none;
}

.phone-input {
  width: 100%;
  padding: 14px 12px 14px 3rem;
  /* فضای کافی برای "09" */
  border: 2px solid #a1a1a1;
  border-radius: 8px;
  font-size: 15px;
  direction: ltr;
  text-align: left;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

/* فوکوس */
.phone-input:focus {
  outline: none;
  border-color: #EA6C22;
  box-shadow: 0 4px 12px rgba(234, 108, 34, 0.3);
}

/* لیبل شناور */
.phone-label {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  background-color: #fff;
  color: #555;
  font-size: 15px;
  pointer-events: none;
  transition: all 0.25s ease-in-out;
}

/* وقتی فوکوس یا مقدار دارد */
.phone-input:focus~.phone-label,
.phone-input:not(:placeholder-shown)~.phone-label {
  top: 0;
  font-size: 13px;
  color: #EA6C22;
  padding: 0 6px;
}

/* حالت خطا */
.has-error {
  border-color: #e74c3c !important;
  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.15);
}

.phone-error {
  color: #e74c3c;
  font-size: 13px;
  margin-top: 6px;
  display: block;
}



.order-count-select {
  width: 150px;
  padding: 7px 14px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #fafafa;
  outline: none;
  pointer-events: none;

  font-size: 14px;
  color: #555;

  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.order-count-select option {
  font-size: 16px;
  color: #555;
}

@media (max-width:820px) {
  .order-count-select {
    font-size: 11px;
  }
}








.cards-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* دو ستون در موبایل */
  gap: 24px;
  max-width: 1200px;
}





@media (max-width:820px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    max-width: 410px;


  }

  .stat-card {
    height: 130px;


  }

  .card-value {
    font-size: 0px;


  }



}


@media (min-width: 1024px) {
  .cards-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.stat-card {
  background-color: white;
  border-radius: 12px;
  padding: 10px;
  border: 1px solid #eeee;
  transition: all 0.3s ease;
  border-right: 4px solid #EA6C22;

}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.card-data {
  flex: 1 1;
}

.card-label {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 8px;
}

.card-value {
  font-size: 32px;
  font-weight: 700;
  color: #111827;
}

.card-trend {
  font-size: 13px;
  margin-top: 8px;
  display: flex;
  align-items: center;
}

.icon-container {
  width: 56px;
  height: 56px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}





.info-row2 {
  /* display: flex;
  align-items: flex-start; */
  background: #fafafa;
  border-radius: 8px;
  padding: 0.6rem 1rem;
  transition: background 0.3s ease;
  flex-wrap: wrap;
}

.seller-list {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.seller-row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 10px 12px;
  border-radius: 8px;

  background: #f8f9fb;
  border: 1px solid #e5e7eb;
}

.seller-name {
  font-size: 14px;
  color: #111827;
  font-weight: 500;
}

.seller-status {
  font-size: 12px;
  padding: 4px 10px;

  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #f3f4f6;
  color: #6b7280;

  cursor: not-allowed;
}


.info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.info-label {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.excel-btn {
  font-size: 13px;
  padding: 6px 12px;

  border-radius: 8px;
  border: 1px solid #22c55e;
  background: #ecfdf5;
  color: #15803d;

  cursor: pointer;
  transition: all 0.2s ease;
}

.excel-btn:hover {
  background: #22c55e;
  color: #fff;
}
.seller-name {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.seller-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.seller-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;

  font-size: 12px;
  color: #6b7280;
}

.seller-meta .dot {
  font-size: 10px;
  opacity: 0.6;
}

.seller-address {
  font-size: 12px;
  color: #374151;
}



.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-btn {
  font-size: 12px;
  padding: 6px 12px;

  border-radius: 8px;
  border: 1px dashed #d1d5db;

  background: #f9fafb;
  color: #374151;

  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/Table.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;;AAEnB;;AAEA;EACE,iBAAiB;;AAEnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;;AAEpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE;IACE,YAAY;IACZ,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;;AAGA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;;EAErB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;;;;AAKA;EACE,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,YAAY;AACd;;;;AAIA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,wCAAwC;AAC1C;;;;AAIA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;AACrB;;;;;;AAMA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmEG;;;AAGH;;gEAEgE;AAChE;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,gDAAgD;EAChD,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;;;;;AAMA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;;;;;AAMA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;;EAEd,oBAAoB;AACtB;;;;;;;;;AASA;;mCAEmC;AACnC;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0DAA0D;EAC1D,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;;EAEE,MAAM;EACN,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;;;AAIA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;;EAEpB,eAAe;EACf,WAAW;;EAEX,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;;;;;;;;AASA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;;;;;AAMA;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,gBAAgB;;;EAGlB;;EAEA;IACE,aAAa;;;EAGf;;EAEA;IACE,cAAc;;;EAGhB;;;;AAIF;;;AAGA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;;AAEjC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;;;;;AAMA;EACE;4BAC0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,kBAAkB;EAClB,kBAAkB;;EAElB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;;EAEd,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;;EAEd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;;EAER,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,kBAAkB;EAClB,0BAA0B;;EAE1B,mBAAmB;EACnB,cAAc;;EAEd,eAAe;AACjB","sourcesContent":[".table-container {\n  width: 100%;\n  overflow-x: auto;\n  /* اسکرول افقی */\n  margin-top: 20px;\n  font-family: 'Vazir', sans-serif;\n  -webkit-overflow-scrolling: touch;\n  /* اسکرول نرم در موبایل */\n}\n\n.table-container table {\n  width: 100%;\n  min-width: 700px;\n  /* پیش‌فرض برای دسکتاپ */\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 14px;\n  text-align: right;\n\n}\n\nth {\n  text-align: right;\n\n}\n\n.table-container thead {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.table-container thead th {\n  padding: 12px 15px;\n  font-weight: 600;\n  color: #333;\n  text-align: right;\n}\n\n.table-container tbody tr:nth-child(odd) {\n  background-color: #F7F6FE;\n  border-radius: 8px;\n\n}\n\n.table-container tbody tr:nth-child(even) {\n  background-color: #ffffff;\n}\n\n.table-container tbody tr:hover {\n  background-color: #f0f5ff;\n}\n\n.table-container tbody td {\n  padding: 12px 15px;\n  border-bottom: 1px solid #eee;\n  color: #555;\n}\n\n.actions-cell {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 15px;\n}\n\n.delete-btn {\n  color: #e74c3c;\n}\n\n.tooltip-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.tooltip-button:hover {\n  transform: scale(1.1);\n}\n\n.tooltip-button img {\n  width: 20px;\n  height: 20px;\n}\n\n/* --- رسپانسیو --- */\n@media (max-width: 768px) {\n  .table-container table {\n    width: 300px;\n    /* عرض ثابت جدول در موبایل */\n    font-size: 13px;\n  }\n\n  .table-container {\n    width: 300px;\n    /* عرض ثابت جدول در موبایل */\n  }\n\n  .table-container thead th,\n  .table-container tbody td {\n    padding: 10px 8px;\n  }\n\n  .tooltip-button img {\n    width: 18px;\n    height: 18px;\n  }\n\n  .actions-cell {\n    flex-direction: column;\n    /* دکمه‌ها زیر هم */\n    gap: 5px;\n  }\n}\n\n@media (max-width: 480px) {\n  .table-container table {\n    width: 300px;\n    /* ثابت بودن عرض */\n    font-size: 12px;\n  }\n\n  .table-container thead th,\n  .table-container tbody td {\n    padding: 8px 5px;\n  }\n}\n\n\n/* ---------- مودال ---------- */\n.edit-modal {\n  display: none;\n  position: fixed;\n  inset: 0;\n  z-index: 999;\n  background: rgba(0, 0, 0, 0.5);\n  overflow-y: auto;\n}\n\n.edit-modal-content {\n  background: #fff;\n  margin: 5% auto;\n  padding: 20px;\n  max-width: 480px;\n  border-radius: 10px;\n  position: relative;\n}\n\n.close-modal {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n  cursor: pointer;\n  font-size: 22px;\n}\n\n.edit-modal-content label {\n  display: block;\n  margin-top: 12px;\n}\n\n.edit-modal-content input,\n.edit-modal-content select {\n  width: 100%;\n  padding: 6px;\n  margin-top: 4px;\n  box-sizing: border-box;\n}\n\n.actions-cell {\n  display: flex;\n  gap: 6px;\n}\n\n/* ---------- دکمه‌های tooltip ---------- */\n.tooltip-btn {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: none;\n  background-color: #EA6C22;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n}\n\n.tooltip {\n  position: absolute;\n  top: -20px;\n  opacity: 0;\n  background-color: #000000;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition-duration: 0.2s;\n  pointer-events: none;\n  letter-spacing: 0.5px;\n\n  z-index: 99999;\n}\n\n.tooltip-btn:hover .tooltip {\n  top: -50px;\n  opacity: 1;\n  transition-duration: 0.3s;\n}\n\n\n.pagination-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 16px;\n}\n\n\n\n\n.delete-btn {\n  color: #fff;\n  background-color: #ebebeb;\n  /* قرمز */\n  border: none;\n}\n\n\n\n.product-cell {\n  position: relative;\n  padding: 6px 8px;\n  font-size: 14px;\n  vertical-align: middle;\n}\n\n.product-cell .product-name {\n  font-weight: 500;\n  color: #333;\n  font-size: 15px;\n}\n\n.product-cell .product-quantity {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background-color: #EA6C22;\n  color: #fff;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 0 6px;\n  margin-left: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n\n\n/* استایل خلاصه محصولات انتخاب‌شده */\n.selected-products-summary {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: #fafafa;\n}\n\n.selected-products-summary h5 {\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n  /* اندازه متوسط */\n}\n\n.selected-products-summary ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.selected-products-summary li {\n  font-size: 0.875rem;\n  /* کمی کوچک‌تر برای لیست */\n  margin-bottom: 0.25rem;\n}\n\n/* نمونه استایل برای دکمه افزودن محصول */\n.btn-add-product {\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n  background: #4caf50;\n  color: #fff;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-add-product:hover {\n  background: #43a047;\n}\n\n\nh3.form-title {\n  margin-bottom: 20px;\n}\n\n\n\n\n\n/* \n.selected-products-summary {\n  margin-top: 1.5rem;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fdfdfd;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n.selected-products-summary h5 {\n  font-size: 16px;\n  margin-bottom: 0.75rem;\n  color: #333;\n}\n\n.selected-products-summary ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.selected-product-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n  color: #555;\n  transition: background-color 0.2s;\n}\n\n.selected-product-item:last-child {\n  border-bottom: none;\n}\n\n.selected-product-item:hover {\n  background-color: #f5f5f5;\n}\n\n.selected-product-item span {\n  flex: 1;\n}\n\n.btn-remove-product {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  color: #e74c3c;\n  transition: transform 0.2s, color 0.2s;\n}\n\n.btn-remove-product:hover {\n  transform: scale(1.3);\n  color: #c0392b;\n}\ntr{\n      background: #f9fafb;\n    padding: 12px;\n    border-radius: 14px;\n    display: flex\n;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid #e5e7eb;\n} */\n\n\n/* ===========================================================\n   Selected Products Section\n   =========================================================== */\n.selected-products {\n  direction: rtl;\n  /* پشتیبانی از زبان فارسی */\n  padding: 1.5rem;\n  background-color: #f9f9f9;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  margin-top: 1rem;\n}\n\n/* ---------- عنوان بخش ---------- */\n.selected-products .modal-title {\n  font-size: 24px;\n  /* می‌توانید اندازه دلخواه خود را جایگزین کنید */\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: #333;\n  text-align: center;\n}\n\n/* ---------- لیست محصولات ---------- */\n.selected-products ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.selected-products ul li {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n  padding: 0.75rem 1rem;\n  margin-bottom: 0.75rem;\n  border-radius: 8px;\n  border: 1px solid #e5e5e5;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.selected-products ul li:hover {\n  background-color: #f3f3f3;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n/* ---------- متن محصول ---------- */\n.selected-products ul li span {\n  font-size: 16px;\n  /* اندازه متن دلخواه */\n  color: #555;\n  line-height: 1.6;\n}\n\n/* ---------- دکمه حذف ---------- */\n.selected-products ul li .delete-btn {\n  margin-right: 1rem;\n  /* فاصله از متن */\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n}\n\n.selected-products ul li .delete-btn img,\n.selected-products ul li .delete-btn svg {\n  width: 20px;\n  height: 20px;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.selected-products ul li .delete-btn:hover img,\n.selected-products ul li .delete-btn:hover svg {\n  transform: scale(1.1);\n  opacity: 0.8;\n}\n\n.margin-btn {\n  margin-right: 5px;\n  /* در صورت نیاز به مارجین بیشتر */\n}\n\n\n\n\n\n.product-price span {\n  font-weight: bold;\n  color: #e63946;\n  font-size: 12px;\n}\n\n\n\n\n\n.order-count {\n\n  color: #1f2937;\n  font-size: 16px;\n  font-weight: 800;\n  transition: all 0.3s ease;\n  direction: rtl;\n\n  padding-bottom: 20px;\n}\n\n\n\n\n\n\n\n\n/* ===============================\n   📱 Phone Input Floating Label\n================================= */\n.phone-input-container {\n  position: relative;\n  width: 100%;\n  margin: 20px 0;\n}\n\n.phone-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.phone-prefix {\n  position: absolute;\n  left: 12px;\n  color: #888;\n  font-size: 15px;\n  pointer-events: none;\n}\n\n.phone-input {\n  width: 100%;\n  padding: 14px 12px 14px 3rem;\n  /* فضای کافی برای \"09\" */\n  border: 2px solid #a1a1a1;\n  border-radius: 8px;\n  font-size: 15px;\n  direction: ltr;\n  text-align: left;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease;\n  background-color: #fff;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n/* فوکوس */\n.phone-input:focus {\n  outline: none;\n  border-color: #EA6C22;\n  box-shadow: 0 4px 12px rgba(234, 108, 34, 0.3);\n}\n\n/* لیبل شناور */\n.phone-label {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  background-color: #fff;\n  color: #555;\n  font-size: 15px;\n  pointer-events: none;\n  transition: all 0.25s ease-in-out;\n}\n\n/* وقتی فوکوس یا مقدار دارد */\n.phone-input:focus~.phone-label,\n.phone-input:not(:placeholder-shown)~.phone-label {\n  top: 0;\n  font-size: 13px;\n  color: #EA6C22;\n  padding: 0 6px;\n}\n\n/* حالت خطا */\n.has-error {\n  border-color: #e74c3c !important;\n  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.15);\n}\n\n.phone-error {\n  color: #e74c3c;\n  font-size: 13px;\n  margin-top: 6px;\n  display: block;\n}\n\n\n\n.order-count-select {\n  width: 150px;\n  padding: 7px 14px;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  background: #fafafa;\n  outline: none;\n  pointer-events: none;\n\n  font-size: 14px;\n  color: #555;\n\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);\n}\n\n.order-count-select option {\n  font-size: 16px;\n  color: #555;\n}\n\n@media (max-width:820px) {\n  .order-count-select {\n    font-size: 11px;\n  }\n}\n\n\n\n\n\n\n\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  /* دو ستون در موبایل */\n  gap: 24px;\n  max-width: 1200px;\n}\n\n\n\n\n\n@media (max-width:820px) {\n  .cards-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    max-width: 410px;\n\n\n  }\n\n  .stat-card {\n    height: 130px;\n\n\n  }\n\n  .card-value {\n    font-size: 0px;\n\n\n  }\n\n\n\n}\n\n\n@media (min-width: 1024px) {\n  .cards-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.stat-card {\n  background-color: white;\n  border-radius: 12px;\n  padding: 10px;\n  border: 1px solid #eeee;\n  transition: all 0.3s ease;\n  border-right: 4px solid #EA6C22;\n\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.card-data {\n  flex: 1;\n}\n\n.card-label {\n  color: #6b7280;\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n\n.card-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.card-trend {\n  font-size: 13px;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.icon-container {\n  width: 56px;\n  height: 56px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n\n\n\n\n.info-row2 {\n  /* display: flex;\n  align-items: flex-start; */\n  background: #fafafa;\n  border-radius: 8px;\n  padding: 0.6rem 1rem;\n  transition: background 0.3s ease;\n  flex-wrap: wrap;\n}\n\n.seller-list {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.seller-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  padding: 10px 12px;\n  border-radius: 8px;\n\n  background: #f8f9fb;\n  border: 1px solid #e5e7eb;\n}\n\n.seller-name {\n  font-size: 14px;\n  color: #111827;\n  font-weight: 500;\n}\n\n.seller-status {\n  font-size: 12px;\n  padding: 4px 10px;\n\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  background: #f3f4f6;\n  color: #6b7280;\n\n  cursor: not-allowed;\n}\n\n\n.info-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.info-label {\n  font-size: 15px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.excel-btn {\n  font-size: 13px;\n  padding: 6px 12px;\n\n  border-radius: 8px;\n  border: 1px solid #22c55e;\n  background: #ecfdf5;\n  color: #15803d;\n\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.excel-btn:hover {\n  background: #22c55e;\n  color: #fff;\n}\n.seller-name {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.seller-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.seller-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.seller-meta .dot {\n  font-size: 10px;\n  opacity: 0.6;\n}\n\n.seller-address {\n  font-size: 12px;\n  color: #374151;\n}\n\n\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.count-btn {\n  font-size: 12px;\n  padding: 6px 12px;\n\n  border-radius: 8px;\n  border: 1px dashed #d1d5db;\n\n  background: #f9fafb;\n  color: #374151;\n\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
